import styled from "styled-components";

export const StyleDepositedNFT = styled.div`
  width: 219px;
  min-width: 219px;
  max-width: 219px;
  height: 335px;
  min-height: 335px;
  max-height: 335px;

  border-radius: 8px;
  background: rgba(203, 215, 255, 0.016);
`;
